// Wait for the DOM to be fully loaded
document.addEventListener("DOMContentLoaded", function () {
  // Select all thumbnail buttons
  var thumbnails = document.querySelectorAll(".thumbnail-button");

  // Function to handle the click event
  function scrollToImage(event) {
    // Prevent the default anchor behavior
    event.preventDefault();

    // Get the href attribute of the clicked thumbnail
    var href = this.getAttribute("href");

    // Extract the image ID from the href
    var imageId = href.split("#")[1];

    // Find the target image using the extracted ID
    var targetImage = document.getElementById(imageId);

    // Check if the target image exists
    if (targetImage) {
      // Calculate the target position for scrolling
      var targetPosition = targetImage.getBoundingClientRect();

      // Scroll to the target image smoothly
      targetImage.parentNode.scrollBy({
        left: targetPosition.left,
        behavior: "smooth",
      });
    }
  }

  // Attach the click event listener to each thumbnail
  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", scrollToImage);
  });
});
